import { z } from "zod";
import { CompositionConfigLight } from "../../../types";
import { PHOTOS_FOUND_NUM_FRAMES } from "./constants";
import { PhotosFoundGraphicV1Props } from "./types";

const PhotosFoundGraphicV1Config: CompositionConfigLight<PhotosFoundGraphicV1Props> = {
	name: "PhotosFoundGraphicV1",
	assertValidProps: (props) => {
		return z
			.object({
				renderStatic: z.boolean().optional(),
			})
			.parse(props) satisfies PhotosFoundGraphicV1Props;
	},
	videoConfig: {
		numFrames: (props) => (props.renderStatic ? 1 : PHOTOS_FOUND_NUM_FRAMES),
		width: 1080,
		height: 1920,
	},
};

export default PhotosFoundGraphicV1Config;
